<template>
  <div class="chat_list w-100 h-100">
    <template v-if="chatsFormattedBySearch.length">
      <ChatListItem
        v-for="(chatItem, key) in chatsFormattedBySearch"
        :key="key"
        :chatItem="chatItem"
        :index="key"
        @contextmenu="
          $refs.ChatContextMenu &&
            $refs.ChatContextMenu.onContext({ contextmenu: $event, targetObj: chatItem })
        "
        :chatTranslations="chatTranslations"
      />
      <ChatContextMenu v-model="chatObj" ref="ChatContextMenu" :items="contextItems" />
    </template>
    <div class="d-flex align-center justify-center gap-3 f16 noData px-5 py-2 w-100 h-100" v-else>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 1.01148e-06H2C0.897 1.01148e-06 0 0.894001 0 1.992V14.008C0 15.106 0.897 16 2 16H5V20L11.351 16H18C19.103 16 20 15.106 20 14.008V1.992C19.9984 1.46279 19.7869 0.95583 19.412 0.582372C19.037 0.208914 18.5292 -0.000531115 18 1.01148e-06ZM14.707 11.293L13.293 12.707L10 9.414L6.707 12.707L5.293 11.293L8.586 8L5.293 4.707L6.707 3.293L10 6.586L13.293 3.293L14.707 4.707L11.414 8L14.707 11.293Z"
          fill="#3B3B3B"
        />
      </svg>

      {{ localStorage.translations.pages.common['text']['net-dannyh'] }}
    </div>
  </div>
</template>

<script>
import ChatListItem from 'components/chat/ChatListItem'
import ChatContextMenu from 'components/chat/contextMenu/ChatContextMenu'
import chat_context from '~/configs/chat/contextMenu'
export default {
  name: 'ChatList',
  components: {
    ChatListItem,
    ChatContextMenu,
  },
  props: {
    chats: { type: Array, default: () => [] },
    search: String,
    chatTranslations: Object,
  },
  data() {
    return { chatObj: null }
  },
  computed: {
    contextItems() {
      return this.chatObj
        ? chat_context({
            chatItem: this.chatObj,
          })
        : []
    },
    chatsFormattedBySearch() {
      const regex = new RegExp(this.search, 'i')
      return this.search.length
        ? this.chats.filter((i) => {
            return i.displayData.name.search(regex) > -1
          })
        : this.chats
    },
  },
}
</script>

<style lang="scss" scoped>
.chat_list {
  &__item {
    &:not(:last-of-type) {
      border-bottom: 1px solid var(--v-secondary-lighten4);
    }
  }
}
</style>
